/**
=========================================================
* Trakib - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useMemo, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete } from "@mui/material";

// Trakib components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Trakib examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import FormField from "components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";

import i18n from "i18n";
import AutocompleteWithPagination from "components/AutocompleteWithPagination";
import prepareNewArr from "helper/prepareNewArr";

const AddDonation = () => {
  const navigate = useNavigate();

  const { t } = i18n;
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [donation, setDonation] = useState({
    user_id: null,
    project_id: null,
    OrderId: "",
    Currency: "",
    PurchAmount: "",
    TransactionDate: "",
    Description: "",
  });

  const [error, setError] = useState({
    user_id: false,
    project_id: false,
    OrderId: false,
    Currency: false,
    PurchAmount: false,
    TransactionDate: false,
    Description: false,
    error: false,
    textError: "",
  });

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       // const usersRes = await CrudService.getAllData(
  //       //   "items/projects?fields=id,translations.name"
  //       // );
  //       // setProjects(usersRes.data);
  //       // const userRes = await CrudService.getAllData(
  //       //   `users?fields=id,first_name,last_name`
  //       // );
  //       // setUsers(userRes.data);
  //     } catch (err) {
  //       console.error(err);
  //       return null;
  //     }
  //   })();
  // }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    const newDonation = {
      project_id: donation.project_id,
      Currency: "949",
      PurchAmount: donation.PurchAmount,
      cost: donation.PurchAmount,
      TransactionDate: new Date(),
      paid_at: new Date(),
      Description: donation.Description,
      user_id: donation.user_id?.id,
      from: "org",
      ProcReturnCode: "00",
      TxnResult: "Success",
      total_amount_original: donation.PurchAmount,
      original_currency: "TRY",
      user: `${donation.user_id.first_name} ${donation.user_id.last_name}`,
      email: donation.user_id.email,
      phone: donation.user_id.phone,
      donation_status: "paid",
      exchange_rate: 1,
      donation_items: [
        {
          project_id: donation.project_id?.id,
          Currency: "949",
          PurchAmount: donation.PurchAmount,
          cost: donation.PurchAmount,
          TransactionDate: new Date(),
          paid_at: new Date(),
          Description: donation.Description,
          user_id: donation.user_id?.id,
          from: "org",
          ProcReturnCode: "00",
          TxnResult: "Success",
          total_amount_original: donation.PurchAmount,
          project: donation.project_id.name,
          user: `${donation.user_id.first_name} ${donation.user_id.last_name}`,
          type: "PROJECT",
          exchange_rate: 1,
          original_currency: "TRY",
        },
      ],
    };

    try {
      const { data } = await CrudService.createItem(
        "items/donation",
        newDonation,
      );
      // const items = await CrudService.createItem("items/donation_items", {
      //   ...newDonation,
      //   project: `${donation.project_id.translations[0].first_name} ${donation.project_id.translations[0].last_name}`,
      //   donation_id: data.id,
      //   type: "project",
      // });
      const providerOrderId = `ARAKAN-${data.id}-${Date.now()}`;
      let o = { OrderId: providerOrderId, provider_order_id: providerOrderId };
      await CrudService.updateItem(`items/donation/${data.id}`, o);
      await CrudService.createItem("api/donation-success", {
        donationId: data.id,
      });

      // navigate("/donationManagement/donations-list", {
      //   state: { value: true, text: t("createSuccessfully") },
      // });
    } catch (err) {
      setError({ ...error, error: true, textError: err.message });
      return null;
    }
  };

  const getUserData = async (name, page, search) => {
    const usersData = await CrudService.getAllData(
      `users?fields=id,first_name,last_name,email,phone${
        search && `&filter[first_name][_contains]=${search}`
      }&page=${page}&limit=${CrudService.getLimit()}`,
    );
    return usersData.data;
  };

  const getProjectData = async (name, page, search) => {
    const projectsData = await CrudService.getAllData(
      `items/projects?fields=id,translations.name,translations.languages_code&filter[translations][languages_code][_eq]=ar-SA${
        search && `&filter[translations][name][_contains]=${search}`
      }&page=${page}&limit=${CrudService.getLimit()}`,
    );
    return prepareNewArr(projectsData.data);
  };

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  {t("addDonation")}
                </MDTypography>
              </MDBox>
            </MDBox>
            <Card>
              <MDBox
                component="form"
                method="POST"
                onSubmit={submitHandler}
                encType="multipart/form-data"
              >
                <MDBox display="flex" flexDirection="column" px={3} my={4}>
                  <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    {/* <AutocompleteWithPagination
                      defaultValue={null}
                      options={projects}
                      getOptionLabel={(option) => {
                        if (option.data) {
                          if (option.data.translations[0].name)
                            return option.data.translations[0].name;
                        } else {
                          if (option) {
                            if (option.translations[0].name)
                              return option.translations[0].name;
                          }
                        }
                        return "";
                      }}
                      value={donation.project_id}
                      isOptionEqualToValue={(option, item) =>
                        option === item || option.id === item.id
                      }
                      onChange={(event, newValue) => {
                        setDonation({
                          ...donation,
                          project_id: newValue,
                        });
                      }}
                      renderInput={(params) => (
                        <FormField
                          {...params}
                          label={t("projects")}
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    /> */}
                    {useMemo(
                      () => (
                        <AutocompleteWithPagination
                          fieldName="name"
                          limit={CrudService.getLimit()}
                          name={"projects"}
                          value={donation.project_id}
                          onChange={(newValue) => {
                            setDonation({
                              ...donation,
                              project_id: newValue,
                            });
                          }}
                          getData={getProjectData}
                          label={"المشاريع"}
                        />
                      ),
                      [
                        CrudService.getLimit(),
                        getProjectData,
                        donation.project_id,
                      ],
                    )}
                    {error.project_id && (
                      <MDTypography
                        variant="caption"
                        color="error"
                        fontWeight="light"
                        pl={4}
                      >
                        {error.textError}
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    {useMemo(
                      () => (
                        <AutocompleteWithPagination
                          fieldName="first_name"
                          limit={CrudService.getLimit()}
                          name={"users"}
                          value={donation.user_id}
                          onChange={(newValue) => {
                            setDonation({
                              ...donation,
                              user_id: newValue,
                            });
                          }}
                          getData={getUserData}
                          label={"الأعضاء"}
                        />
                      ),
                      [CrudService.getLimit(), getUserData, donation.user_id],
                    )}
                    {/* <AutocompleteWithPagination
                      defaultValue={null}
                      options={users}
                      getOptionLabel={(option) => {
                        if (option.data) {
                          if (option.data.first_name)
                            return option.data.first_name;
                        } else {
                          if (option) {
                            if (option.first_name) return option.first_name;
                          }
                        }
                        return "";
                      }}
                      value={donation.user_id}
                      isOptionEqualToValue={(option, item) =>
                        option === item || option.id === item.id
                      }
                      onChange={(event, newValue) => {
                        setDonation({
                          ...donation,
                          user_id: newValue,
                        });
                      }}
                      renderInput={(params) => (
                        <FormField
                          {...params}
                          label={t("users")}
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    /> */}
                    {error.user_id && (
                      <MDTypography
                        variant="caption"
                        color="error"
                        fontWeight="light"
                        pl={4}
                      >
                        {error.textError}
                      </MDTypography>
                    )}
                  </MDBox>
                  {/* <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    <FormField
                      variant="outlined"
                      label={t("OrderId")}
                      placeholder={t("OrderId")}
                      name="OrderId"
                      value={donation.OrderId}
                      onChange={(e) => {
                        setDonation({
                          ...donation,
                          OrderId: e.target.value,
                        });
                      }}
                    />
                  </MDBox> */}
                  {/* <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    <FormField
                      variant="outlined"
                      label={t("Currency")}
                      placeholder={t("Currency")}
                      name="Currency"
                      value={donation.Currency}
                      onChange={(e) => {
                        setDonation({
                          ...donation,
                          Currency: e.target.value,
                        });
                      }}
                    />
                  </MDBox> */}
                  <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    <FormField
                      variant="outlined"
                      label={t("PurchAmount")}
                      placeholder={t("PurchAmount")}
                      name="PurchAmount"
                      value={donation.PurchAmount}
                      onChange={(e) => {
                        setDonation({
                          ...donation,
                          PurchAmount: e.target.value,
                        });
                      }}
                    />
                  </MDBox>
                  {/* <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    <FormField
                      variant="outlined"
                      label={t("TransactionDate")}
                      placeholder={t("TransactionDate")}
                      name="TransactionDate"
                      value={donation.TransactionDate}
                      onChange={(e) => {
                        setDonation({
                          ...donation,
                          TransactionDate: e.target.value,
                        });
                      }}
                    />
                  </MDBox> */}
                  <MDBox display="flex" flexDirection="column" marginTop="2rem">
                    <FormField
                      multiline
                      variant="outlined"
                      rows={5}
                      label={t("details")}
                      placeholder={t("Description")}
                      name="Description"
                      value={donation.Description}
                      onChange={(e) => {
                        setDonation({
                          ...donation,
                          Description: e.target.value,
                        });
                      }}
                    />
                  </MDBox>
                  <MDBox
                    ml="auto"
                    mt={4}
                    mb={2}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <MDButton
                      variant="gradient"
                      color="warning"
                      size="small"
                      px={2}
                      mx={2}
                      onClick={() =>
                        navigate("/donationManagement/donations-list", {
                          state: { value: false, text: "" },
                        })
                      }
                    >
                      {t("back")}
                    </MDButton>
                    <MDButton
                      sx={{ mx: 2 }}
                      variant="gradient"
                      color="secondary"
                      size="small"
                      type="submit"
                    >
                      {t("save")}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AddDonation;
